import { ObjectType } from "./helpers/models";


export type IntegrationRequirements<T = any> = {
    /** tells whether integration needs be configured with a tray iframe. Instance must have `wizard_url` field */
    iframe?: T;
    /** tells whether integration needs to manage locations */
    locations?: T,
    /** whether this is a sandbox-dev environemnt or not */
    sandbox?: T
    selfOnboard?: boolean
}

export interface IntegrationConfig {
    info: string
    wording?: IntegrationRequirements<string>
    features: IntegrationRequirements<boolean>
}

export enum Platform {
    square = "square",
    square_sandbox = "square-sandbox",
    /** uber eats KH bridge */
    uberEatsKH = "uber-eats",
    toast = "toast",
    toast_sandbox = "toast-sandbox"
}

/** all available integrations 
 * @note integrations without sandbox env will be available in dev ( so changes can be tested while staging )
 * todo: need to change this in the future, so changes in dev will never affect production. This is a workaround to get results fast
 */
export const platforms = {
    prod: [
        Platform.square,
        Platform.toast,
        Platform.uberEatsKH
    ],
    dev: [
        Platform.square_sandbox,
        Platform.toast_sandbox,
        Platform.uberEatsKH
    ]
}


export interface IntegrationProfile {
    /** 
     * @tray UUID referencing solution instance ID 
     * @dynamoDb global index primary key
     * */
    ext_ref: string;
    /**
     * @tray solution instance name
     * @dynamoDb global index primary key of integration profile
     *  */
    ext_title?: string;
    /** whether solution instance or integration profile is enabled for order sync */
    enabled: boolean;
    /** whether solution instance needs to be updated/upgraded 
     * @deprecated
    */
    outdated?: boolean;
    /** platform related solution instance or integraion profile */
    platform: Platform;
    /** 
    * @tray Whether solution initial configuration was finished 
    * @dynamoDb Whether access token ( or other stuff ) is provided
    */
    completed: boolean;
    /** solution instance  contains authentication details ( oauth or similar) 
     * @deprecated */
    authenticated?: boolean;
    /** @experimental Only relevant in the fe */
    status?: "deleting" | "synching" | "starting" | "error",
    vromo_group?: string
    /** also known as "vromo accoount" */
    vromo_root_group?: string
    ext_locations?: IntegrationLocation[]
    features?: {
        /** url to delete this integration */
        delete?: string;
        /** url to fetch this integration locations */
        locations?: string;
        /** url to finish this integration configuration */
        finish?: string;
        /** @tray solution instance config dialog AuthOnly url */
        configAuthOnlyUrl?: string;
        /** @tray solution instance config dialog url */
        wizardUrl?: string;
        /** url to edit a particular this integration location */
        editLocation?: string;
    }
}


export interface IntegrationLocation {
    /** restaurant owner 
     * @note known as "merchant_id"
    */
    ext_ref: string;
    /** restaurant unique ID */
    ext_site_id?: string;
    /** whether integration location is enabled for order sync */
    enabled: boolean;
    ext_title?: string;
    /** enabled/disabled from platform origin */
    ext_active?: boolean;
}



export const IntegrationsConfig: ObjectType<IntegrationConfig> = {
    [Platform.square]: {
        info: "this integration reads delivery orders from your Square Seller Account and display them in your VROMO Account. On the next screen, you will be asked to Grant VROMO Access to your Square Delivery Orders",
        wording: {
            iframe: `square oauth configuration`
        },
        features: {
            iframe: true,
            locations: true,
            selfOnboard: true
        },
    },
    [Platform.square_sandbox]: {
        info: "SANDBOX MODE - this integration reads delivery orders from your Square Seller Account and display them in your VROMO Account. On the next screen, you will be asked to Grant VROMO Access to your Square Delivery Orders",
        wording: {
            iframe: `Square SANDBOX oauth configuration`
        },
        features: {
            iframe: true,
            locations: true,
            sandbox: true,
            selfOnboard: true
        },
    },
    [Platform.toast]: {
        info: "this integration reads delivery orders from your Toast managment Group enabled restaurants and not only display them in your VROMO Account, but also postback certain Vromo job updates to your Toast orders. Please go into your Toast admin panel and add Vromo through Toast Partner connect, in the desired restaurants. A Vromo support person will contact you and finish the configuration",
        features: {
            iframe: false,
            locations: false,
            sandbox: false,
            selfOnboard: false
        },
    },
    [Platform.toast_sandbox]: {
        info: "SANDBOX MODE - this integration reads delivery orders from your Toast managment Group enabled restaurants and not only display them in your VROMO Account, but also postback certain Vromo job updates to your Toast orders. Please go into your Toast admin panel and add Vromo through Toast Partner connect, in the desired restaurants. A Vromo support person will contact you and finish the configuration",
        features: {
            iframe: false,
            locations: false,
            sandbox: true,
            selfOnboard: false
        },
    },
    [Platform.uberEatsKH]: {
        info: "This integration will ingest delivery orders from your Uber Eats merchant Account and display them in your VROMO Account. On the next screen, you will be asked to login into UberEats and then provide the info to sync a new location. It will also postback certain updates from Vromo job to Uber Eats orders",
        features: {
            iframe: false,
            locations: true,
            sandbox: false,
            selfOnboard: false
        },
    }
}